import { gql } from '@apollo/client';

export const GET_FEATURE_LIST = gql`
  query GetFeatureList {
    companyFeatures
  }
`;
